var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import AssemblyTableRow from "../components/projecttablerows/assemblytablerow.vue";
import PartTableRow from "../components/projecttablerows/parttablerow.vue";
import QuickActionsTableRow from "../components/quickactions/tablerow.vue";
import WarningDialog from "../components/dialog/warningdialog.vue";
import SectionRow from "../components/sectionrow.vue";
import { objEq, } from "./utilities/aux";
import { isDialogData, } from "./utilities/dialog";
import { CheckedState, Column, checkedState, createDisplayProject, filterDisplayProject, formatPrice, isDisplayAssembly, isRowDisplayInformation, orderedColumnNames, sortDisplayProject, } from "./utilities/projecttable";
const iconColumns = [
    Column.checkbox,
    Column.collapsedState,
    Column.thumbnailAssembly,
    Column.thumbnailPart,
];
let ProjectTableView = class ProjectTableView extends Vue {
    constructor() {
        super(...arguments);
        this.clickHappened = false;
        this.currentSearchText = "";
        this.openedRootIdKey = "";
        this.selection = [];
        this.sortedColumn = {
            columnName: Column.partState,
            up: true,
        };
        this.hasArticleDataChanged = false;
        this.showUncommittedChangesWarning = false;
    }
    openDialog(data) {
        if (!isDialogData(data)) {
            throw Error("projectTableView(): Error opening dialog: Wrong type");
        }
        return data;
    }
    openPartCreationDialog() { }
    openDeletionDialog(data) {
        if (!isDialogData(data)) {
            throw Error("projectTableView(): Error opening dialog: Wrong type");
        }
        return data;
    }
    articleDataChange(b) {
        this.hasArticleDataChanged = b;
        return b;
    }
    updateSelection(rootIdKey) {
        const index = this.selection.indexOf(rootIdKey);
        if (index !== -1) {
            this.selection.splice(index, 1);
        }
        else {
            this.selection.push(rootIdKey);
        }
    }
    projectEntry(vertexKey) {
        const singlePart = this.project.singleParts.find(s => s.vertexKey === vertexKey);
        if (singlePart !== undefined) {
            return singlePart;
        }
        const entry = this.project.assemblies.reduce((res, a) => {
            if (res !== undefined) {
                return res;
            }
            if (a.vertexKey === vertexKey) {
                return a;
            }
            return a.parts.find(p => p.vertexKey === vertexKey);
        }, undefined);
        if (entry === undefined) {
            throw Error("Missing vertexKey.");
        }
        return entry;
    }
    displayProjectEntry(vertexKey) {
        const singlePart = this.displayProject.singleParts.find(s => s.vertexKey === vertexKey);
        if (singlePart !== undefined) {
            return singlePart;
        }
        const entry = this.displayProject.assemblies.reduce((res, a) => {
            if (res !== undefined) {
                return res;
            }
            if (a.assembly.vertexKey === vertexKey) {
                return a;
            }
            return a.parts.find(p => p.vertexKey === vertexKey);
        }, undefined);
        if (entry === undefined) {
            throw Error("Missing vertexKey.");
        }
        return entry;
    }
    handleSelection() {
        if (this.overallCheckState !== CheckedState.all) {
            this.selection = [
                ...this.displayProject.singleParts.map(s => s.rootIdKey),
                ...this.displayProject.assemblies.reduce((res, a) => [
                    ...res,
                    ...a.parts.map(p => p.rootIdKey),
                ], []),
            ].filter((value, index, self) => self.indexOf(value) === index);
        }
        else {
            this.selection = [];
        }
    }
    onRowClicked(rootIdKey) {
        if (!this.hasArticleDataChanged) {
            this.clickHappened = true;
            this.openedRootIdKey = this.openedRootIdKey === rootIdKey ? "" : rootIdKey;
        }
        else {
            this.showUncommittedChangesWarning = true;
        }
    }
    isOpened(rootIdKey) {
        return this.openedRootIdKey === rootIdKey;
    }
    updateSinglePartsSelection() {
        if (this.singlePartsSectionCheckState !== CheckedState.all) {
            this.selection = [
                ...this.selection,
                ...this.displayProject.singleParts.map(s => s.rootIdKey),
            ].filter((value, index, self) => self.indexOf(value) === index);
        }
        else {
            this.selection = this.selection.filter(s => this.project.singleParts.every(p => p.rootIdKey !== s));
        }
    }
    updateAssemblySectionSelection() {
        if (this.assemblySectionCheckState !== CheckedState.all) {
            this.selection = [
                ...this.selection,
                ...this.displayProject.assemblies.reduce((res, a) => [
                    ...res,
                    ...a.parts.map(p => p.rootIdKey),
                ], []),
            ].filter((value, index, self) => self.indexOf(value) === index);
        }
        else {
            this.selection = this.selection.filter(s => this.displayProject.assemblies.every(a => a.parts.every(p => p.rootIdKey !== s)));
        }
    }
    onAssemblyCheckStateChange(rowDisplayInfo) {
        if (!isRowDisplayInformation(rowDisplayInfo)) {
            throw Error("Wrong type.");
        }
        this.clickHappened = true;
        const displayProjectEntry = this.displayProjectEntry(rowDisplayInfo.vertexKey);
        if (!isDisplayAssembly(displayProjectEntry)) {
            throw Error("Wrong type.");
        }
        if (rowDisplayInfo.checkedState !== CheckedState.all) {
            this.selection = [
                ...this.selection,
                ...displayProjectEntry.parts.map(p => p.rootIdKey),
            ].filter((value, index, self) => self.indexOf(value) === index);
        }
        else {
            this.selection = this.selection.filter(s => displayProjectEntry.parts.every(p => p.rootIdKey !== s));
        }
    }
    onFilterRequest(result) {
        this.currentSearchText = result.searchText;
    }
    columnClass(columnName) {
        return this.sortedColumn.columnName === columnName ? "sortedColumn" : "sortableColumn";
    }
    columnSortType(columnName) {
        return this.sortedColumn.columnName !== columnName ? "" : (this.sortedColumn.up ? "up" : "down");
    }
    sort(columnName) {
        if (this.sortedColumn.columnName === columnName) {
            this.sortedColumn.up = !this.sortedColumn.up;
        }
        else {
            this.sortedColumn = {
                columnName: columnName,
                up: true,
            };
        }
    }
    isAssemblyNextOrEnd(assemblyIndex, partIndex) {
        return this.displayProject.assemblies[assemblyIndex].parts.length === partIndex + 1;
    }
    rowIndex(vertexKey) {
        return this.displayedParts.findIndex(p => p.vertexKey === vertexKey);
    }
    get displayProject() {
        return sortDisplayProject(filterDisplayProject(createDisplayProject(this.project, this.networkBroker.configuration.priceFactors, this.i18n, this.shopConfig, this.selection), this.currentSearchText, this.selection), this.sortedColumn);
    }
    get parts() {
        return [
            ...this.project.singleParts,
            ...this.project.assemblies.reduce((res, ass) => [
                ...res,
                ...ass.parts,
            ], []),
        ];
    }
    get displayedParts() {
        return [
            ...this.displayProject.singleParts,
            ...this.displayProject.assemblies.reduce((res, ass) => [
                ...res,
                ...ass.parts,
            ], []),
        ];
    }
    get singlePartsSectionCheckState() {
        return this.displayProject.singleParts.length === 0 ? CheckedState.none : checkedState(this.displayProject.singleParts.map(a => a.checkedState));
    }
    get assemblySectionCheckState() {
        return this.displayProject.assemblies.length === 0 ? CheckedState.none : checkedState(this.displayProject.assemblies.map(a => a.assembly.checkedState));
    }
    get totalPriceString() {
        return formatPrice(this.price, this.networkBroker.configuration.priceFactors, this.i18n);
    }
    get allElementsHidden() {
        return this.parts.length !== 0 && this.displayProject.singleParts.length === 0 && this.displayProject.assemblies.length === 0;
    }
    get columns() {
        return orderedColumnNames;
    }
    get namedColumns() {
        return this.columns.filter((columnName) => iconColumns.every((c) => c !== columnName));
    }
    get unnamedColumns() {
        const c = this.columns.filter((columnName) => this.namedColumns.every(n => n !== columnName));
        if (c.length + this.namedColumns.length !== this.columns.length) {
            throw Error("Wrong number of columns.");
        }
        return c;
    }
    get priceColumnIndex() {
        return this.columns.indexOf(Column.price);
    }
    get overallCheckState() {
        if (this.displayProject.singleParts.length === 0) {
            return this.assemblySectionCheckState;
        }
        if (this.displayProject.assemblies.length === 0) {
            return this.singlePartsSectionCheckState;
        }
        return checkedState([
            this.singlePartsSectionCheckState,
            this.assemblySectionCheckState,
        ]);
    }
    get dialogData() {
        return {
            selection: this.parts.filter(p => this.selection.some(s => p.rootIdKey === s) && this.displayedParts.some(dp => dp.vertexKey === p.vertexKey)),
        };
    }
    created() {
        this.showUncommittedChangesWarning = false;
    }
    updated() {
        const newSelection = this.selection.filter(s => this.parts.some(p => p.rootIdKey === s));
        if (!objEq(newSelection, this.selection)) {
            this.selection = newSelection;
        }
    }
};
__decorate([
    Prop({ required: true })
], ProjectTableView.prototype, "price", void 0);
__decorate([
    Prop({ required: true })
], ProjectTableView.prototype, "project", void 0);
__decorate([
    Prop({ required: true })
], ProjectTableView.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], ProjectTableView.prototype, "showPartCreationButton", void 0);
__decorate([
    Prop({ required: true })
], ProjectTableView.prototype, "Renderer3d", void 0);
__decorate([
    Inject()
], ProjectTableView.prototype, "networkBroker", void 0);
__decorate([
    Inject()
], ProjectTableView.prototype, "i18n", void 0);
__decorate([
    Emit()
], ProjectTableView.prototype, "openDialog", null);
__decorate([
    Emit()
], ProjectTableView.prototype, "openPartCreationDialog", null);
__decorate([
    Emit()
], ProjectTableView.prototype, "openDeletionDialog", null);
__decorate([
    Emit()
], ProjectTableView.prototype, "articleDataChange", null);
ProjectTableView = __decorate([
    Component({
        components: {
            AssemblyTableRow,
            PartTableRow,
            QuickActionsTableRow,
            SectionRow,
            WarningDialog,
        },
        name: "ProjectTableView",
    })
], ProjectTableView);
export default ProjectTableView;
